import { render } from "./HeaderStats.vue?vue&type=template&id=2f0c955c"
import script from "./HeaderStats.vue?vue&type=script&lang=js"
export * from "./HeaderStats.vue?vue&type=script&lang=js"
script.render = render

export default script